// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1GGpU","col":"CardReaderDesc_col__2CTdm","label":"CardReaderDesc_label__I0V37"};